import client from './client';
import type { User } from '../types/user';

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

// Письмо шлётся по SMTP внутри запроса — общих 8 с может не хватить
const EMAIL_REQUEST_TIMEOUT = 30000;

export async function register(email: string, password: string, referralCode?: string): Promise<AuthResponse> {
  const { data } = await client.post<AuthResponse>(
    '/auth/register',
    {
      email,
      password,
      ...(referralCode ? { referralCode } : {}),
    },
    { timeout: EMAIL_REQUEST_TIMEOUT },
  );
  return data;
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  const { data } = await client.post<AuthResponse>('/auth/login', {
    email,
    password,
  });
  return data;
}

export async function refresh(): Promise<AuthResponse> {
  const { data } = await client.post<AuthResponse>('/auth/refresh');
  return data;
}

export async function logout(): Promise<void> {
  // No server-side logout for now
}

export async function getMe(): Promise<User> {
  const { data } = await client.get<User>('/auth/me');
  return data;
}

export async function verifyEmail(code: string): Promise<void> {
  await client.post('/auth/verify-email', { code });
}

export async function resendVerification(): Promise<void> {
  await client.post('/auth/resend-verification', undefined, { timeout: EMAIL_REQUEST_TIMEOUT });
}

export async function forgotPassword(email: string): Promise<void> {
  await client.post('/auth/forgot-password', { email }, { timeout: EMAIL_REQUEST_TIMEOUT });
}

export async function resetPassword(
  email: string,
  code: string,
  newPassword: string,
): Promise<void> {
  await client.post('/auth/reset-password', { email, code, newPassword });
}
